var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11705 0.360329L14.9045 12.2522C14.9671 12.3618 15 12.4861 15 12.6126C15 12.7391 14.9671 12.8634 14.9045 12.973C14.842 13.0825 14.7521 13.1735 14.6438 13.2368C14.5354 13.3 14.4126 13.3333 14.2875 13.3333H0.712505C0.587433 13.3333 0.464565 13.3 0.35625 13.2368C0.247935 13.1735 0.15799 13.0825 0.0954555 12.973C0.0329206 12.8634 -7.94343e-07 12.7391 0 12.6126C7.94372e-07 12.4861 0.0329239 12.3618 0.09546 12.2522L6.88295 0.360329C6.94549 0.250774 7.03544 0.1598 7.14375 0.0965492C7.25207 0.0332985 7.37493 0 7.5 0C7.62507 0 7.74793 0.0332985 7.85625 0.0965492C7.96456 0.1598 8.05451 0.250774 8.11705 0.360329ZM6.78748 9.72972V11.1712H8.21252V9.72972H6.78748ZM6.78748 4.68466V8.28828H8.21252V4.68466H6.78748Z",
    fill: "#FA7319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning_triangle.9257cecafde5b1666b4a777bc83a41fc.svg";
export { ForwardRef as ReactComponent };